import { ISchedule, ScheduleActions } from '../../schedule/types/ISchedule';
import { IScheduleInfo } from '../../schedule/types/IScheduleInfo';
import { Messages } from '../../codegen/Localize';
import { L10n } from '~src/ts/L10n/L10n';
import { Set } from '~src/ts/models/Set';

export namespace DeleteSchedulesActionService {

  export function deleteSingleScheduleBodyText(schedule: IScheduleInfo): string {
    const scheduleSet = Set.singletonForIdItem(schedule);
    const extractTaskCount = countExtractTasks(scheduleSet);
    const subscriptionScheduleCount = countSubscriptionSchedules(scheduleSet);
    const runFlowTaskCount = countFlowTasks(scheduleSet);

    if (subscriptionScheduleCount > 0) {
      return Messages.confirmDeleteSubscriptionSchedule({
        SCHEDULE_NAME: L10n.elideIfLong(schedule.name)
      });
    } else if (runFlowTaskCount > 0) {
      return Messages.confirmDeleteRunFlowTaskSchedule({
        SCHEDULE_NAME: L10n.elideIfLong(schedule.name),
        FLOW_COUNT: runFlowTaskCount,
        FLOW_COUNT_LOC: L10n.localizedCount(runFlowTaskCount),
      });
    } else {
      return Messages.confirmDeleteExtractRefreshSchedule({
        SCHEDULE_NAME: L10n.elideIfLong(schedule.name),
        EXTRACT_COUNT: extractTaskCount,
        EXTRACT_COUNT_LOC: L10n.localizedCount(extractTaskCount),
      });
    }
  }

  // returns the number of extract tasks in the given set of schedules
  function countExtractTasks(schedules: Set<ISchedule>) {
    return schedules.reduce(
      (sum: number, s: ISchedule) => sum + (s.scheduledAction === ScheduleActions.Extract ? s.taskCount : 0), 0);
  }

  // returns the number of subscription schedules in the given set of schedules
  function countSubscriptionSchedules(schedules: Set<ISchedule>) {
    return schedules.reduce(
      (sum: number, s: ISchedule) => sum + (s.scheduledAction === ScheduleActions.Subscription ? 1 : 0), 0);
  }

    // returns the number of flow tasks in the given set of schedules
    function countFlowTasks(schedules: Set<ISchedule>) {
      return schedules.reduce(
        (sum: number, s: ISchedule) => sum + (s.scheduledAction === ScheduleActions.Flow ? s.taskCount : 0), 0);
      }

}